var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tiptap',{staticClass:"tiptap-container",attrs:{"extensions":_vm.extensions,"content":_vm.tipTapInitialContent,"placeholder":"Write something ...","output":"json","editorProperties":{
    editorProps: {
      handleDoubleClick: _vm.handleDoubleClick,
    },
  }},on:{"onInit":_vm.handleInit,"onUpdate":_vm.handleUpdate,"onTransaction":_vm.handleTransaction}})}
var staticRenderFns = []

export { render, staticRenderFns }